(function ($) {
  jQuery(document).ready(function () {
    $(".announcement-bar-section i").click(function () {
      $(".announcement-bar-section").css("height", "0px");
    });
  });
})(jQuery);
